export const CustomElement = (name: string) => (target: CustomElementConstructor) => {
  if (!customElements.get(name)) {
    customElements.define(name, target);
  }
};
